import { createStore } from "vuex";
import services from "./modules/services";
import pricing from "./modules/pricing";

export default createStore({
  modules: {
    services,
    pricing,
  },
});
